import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createAirport, updateAirport, deleteAirport } from "./api";
import { AirportsKeys } from "./queries";
import type { Airport, CreateAirportPayload, UpdateAirportPayload } from "./types";

export function useCreateAirportMutation() {
  const qc = useQueryClient();
  return useMutation<Airport, Error, CreateAirportPayload>({
    mutationFn: (payload) => createAirport(payload),
    onSuccess(created) {
      qc.setQueryData<Airport>(AirportsKeys.detail(created.id), created);
      qc.invalidateQueries({ queryKey: AirportsKeys.all });
    },
  });
}

export function useUpdateAirportMutation(id: number | string) {
  const qc = useQueryClient();
  return useMutation<Airport, Error, UpdateAirportPayload>({
    mutationFn: (payload) => updateAirport(id, payload),
    onSuccess(updated) {
      qc.setQueryData<Airport>(AirportsKeys.detail(id), updated);
      qc.invalidateQueries({ queryKey: AirportsKeys.all });
    },
  });
}

export function useDeleteAirportMutation() {
  const qc = useQueryClient();
  return useMutation<{ message: string } | void, Error, number | string>({
    mutationFn: (id) => deleteAirport(id),
    onSuccess(_res, id) {
      qc.removeQueries({ queryKey: AirportsKeys.detail(id) });
      qc.invalidateQueries({ queryKey: AirportsKeys.all });
    },
  });
}
